import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-percentage',
  templateUrl: './percentage.component.html',
  styleUrls: ['./percentage.component.css']
})
export class PercentageComponent implements OnInit {

  constructor() { }

  @Input() ratio: number;
  ngOnInit() {
  }

}
